import { createBrowserClient } from "@supabase/ssr";

/**
 * Browser (anon) Supabase client — safe for client components.
 * Uses the publishable/anon key; all privileged work goes through
 * SECURITY DEFINER RPCs, never direct table writes (see schema migrations).
 */
export function createClient() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
  );
}
